import "./style.css";
import { useState, useEffect, useCallback } from "react";

import {
  fetchBranchData,
  initBranchState,
} from "../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../redux/slices/departmentSlice";
import { fetchData, initShiftState } from "../../redux/slices/shiftsSlice";

import { useDispatch, useSelector } from "react-redux";

// Child Components ------------------------------
import PayrollConfigurationList from "./components/PayrollConfigurationList";
import PayrollConfiguration from "./components/PayrollConfiguration";
import PayrollSummary from "./components/PayrollSummary/index";
import RunPayroll from "./components/RunPayroll/index.js";
import Advance from "./components/Advance/index.js";
import Incentive from "./components/Incentive/index.js";
import Reimbursement from "./components/Reimbursement/index.js";
import PaymentHistory from "./components/PaymentHistory/index.js";
import TDS from "./components/TDS/index.js";
import { HasPermission } from "../../services/hasPermission.js";

const Payroll = () => {
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user_data")) || {}

  const branchState = useSelector((state) => state.branch);
  const departState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);

  const getData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchData(user.user_id));
  }, []);

  const tabs = [
    {
      tab: "Payroll Summary",
      path: "payroll-summary",
      isAccess: HasPermission("Payroll Summary", "view"),
    },
    {
      tab: "Run Payroll",
      path: "run-payroll",
      isAccess: HasPermission("Run Payroll", "view"),
    },
    {
      tab: "Advance",
      path: "advance",
      isAccess: HasPermission("Advance", "view"),
    },
    {
      tab: "Incentive",
      path: "incentive",
      isAccess: HasPermission("Incentive", "view"),
    },
    {
      tab: "Reimbursement",
      path: "reimbursement",
      isAccess: HasPermission("Reimbursement", "view"),
    },
    {
      tab: "TDS",
      path: "tds",
      isAccess: HasPermission("TDS", "view"),
    },
    {
      tab: "Payment History",
      path: "payment-history",
      isAccess: HasPermission("Payment History", "view"),
    },
    {
      tab: "Payroll Configuration",
      path: "payroll-configurations",
      isAccess: HasPermission("Payroll Configurations", "view"),
    },
  ];

  const [activeTab, setActiveTab] = useState("");
  const [activeList, setActiveList] = useState(true);

  const [branch, setBranch] = useState([]);
  const [depart, setDepart] = useState([]);
  const [shift, setShift] = useState([]);

  // ✅ Strip hash from URL and set first permitted tab on mount
useEffect(() => {
  const savedTab = sessionStorage.getItem("payrollTab");
  sessionStorage.removeItem("payrollTab");

  if (savedTab) {
    const matchedTab = tabs.find((item) => item.path === savedTab && item.isAccess === true);
    if (matchedTab) {
      setActiveTab(matchedTab.path);
      return;
    }
  }

  const firstAccessible = tabs.find((item) => item.isAccess === true);
  if (firstAccessible) {
    setActiveTab(firstAccessible.path);
  }
}, []);
  // useEffect(() => {
  //   if (branchState.brnGetSuccess) {
  //     setBranch(branchState.brnGetData);
  //     dispatch(initBranchState());
  //   }

  //   if (departState.depGetSuccess) {
  //     setDepart(departState.depGetData);
  //     dispatch(initDepartState());
  //   }

  //   if (shiftState.shiftGetSuccess) {
  //     setShift(shiftState.shiftGetData);
  //     dispatch(initShiftState());
  //   }
  // }, [
  //   branchState.brnGetSuccess,
  //   departState.depGetSuccess,
  //   shiftState.shiftGetSuccess,
  // ]);

  const date = new Date();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "long" });

  const activateTab = (data) => {
    setActiveTab(data.path);
  };

  return (
    <>
      <div className="tab-container payroll-header">
        {tabs.map((row, idx) => {
          return (
            row.isAccess && (
              <div
                className={
                  activeTab === row.path ? `payroll-tab active` : `payroll-tab`
                }
                onClick={() => {
                  activateTab(row);
                }}
                key={idx}
              >
                {row.tab}
              </div>
            )
          );
        })}
      </div>

      <div className="page-body mt-5">
        {activeTab == "payroll-configurations" && (
          <div>
            {activeList ? (
              <PayrollConfigurationList onChange={setActiveList} />
            ) : (
              <PayrollConfiguration onChange={setActiveList} />
            )}
          </div>
        )}

        {activeTab == "payroll-summary" && <PayrollSummary />}
        {activeTab == "run-payroll" && <RunPayroll />}
        {activeTab == "advance" && <Advance />}
        {activeTab == "incentive" && <Incentive />}
        {activeTab == "reimbursement" && <Reimbursement />}
        {activeTab == "tds" && <TDS />}
        {activeTab == "payment-history" && <PaymentHistory />}
      </div>
    </>
  );
};

export default Payroll;


